export default "__VITE_ASSET__9U1P4r3g__"